export default function jobPostingSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        "title": "Sales & Service Executive",
        "description":
            "We are hiring a Sales & Service Executive for insurance, CCTV, and computer services.",
        "employmentType": "FULL_TIME",

        "hiringOrganization": {
            "@type": "LocalBusiness",
            "name": "Sujaramaha Enterprises",
            "sameAs": "https://www.sujaramahaenterprises.com"
        },

        "jobLocation": {
            "@type": "Place",
            "address": {
                "@type": "PostalAddress",
                "addressRegion": "Karnataka",
                "addressCountry": "IN"
            }
        },

        "datePosted": "2025-01-01",
        "validThrough": "2026-01-01"
    };
}
